import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postVoucher({ body }) {
  return BaseService.post(REST.VOUCHERS, body);
}

function putVoucher({ body, id }) {
  return BaseService.put(REST.VOUCHERS_ID(id), body);
}

function getVouchers(params) {
  return BaseService.get(REST.VOUCHERS, {
    params: paramsFilter({ params }),
  });
}

function deleteVoucher({ id }) {
  return BaseService.delete(REST.VOUCHERS_ID(id));
}

export default {
  postVoucher,
  putVoucher,
  getVouchers,
  deleteVoucher,
};
